export enum JourneyType {
    Scheduled = "scheduled",
    Calculation = "calculation"
}